import { render, staticRenderFns } from "./logOffManage.vue?vue&type=template&id=1b6e7c1a&"
import script from "./logOffManage.vue?vue&type=script&lang=js&"
export * from "./logOffManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports